import React, { useState } from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateUserRole } from '../../enums/UserRoleEnums';

const ModalForAddUserRole = ({
  handleAdd,
  handleClose,
  show,
  userRoleReducer,
}) => {
  const { error } = userRoleReducer;
  const [initialValues] = useState({ roleName: '' });

  const fields = [
    {
      name: 'roleName',
      label: ModalForAddOrUpdateUserRole.roleNamePlaceholder,
      type: 'text',
    },
  ];

  const handleSubmit = (formData) => {
    handleAdd(formData);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateUserRole.titleForAddRole}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.save}
    />
  );
};

export default ModalForAddUserRole;
